import {
  AcceptCompanyInviteRequestSchema,
  AcceptCompanyInviteResponseSchema,
  type AcceptCompanyInviteRequest,
  type AcceptCompanyInviteResponse,
} from '@crv/contracts/auth';

import { apiPost } from './http-client';

export async function acceptCompanyInvite(
  input: AcceptCompanyInviteRequest,
): Promise<AcceptCompanyInviteResponse> {
  const payload = AcceptCompanyInviteRequestSchema.parse(input);
  return apiPost('/v1/auth/accept-invite', AcceptCompanyInviteResponseSchema, payload);
}

